export const isMouse = (event: Event): boolean => event instanceof MouseEvent;

export const isComboKey = (event: KeyboardEvent): boolean =>
  event.shiftKey || event.ctrlKey || event.metaKey || event.altKey;

export const isEscape = (event: KeyboardEvent): boolean =>
  event.key === "Escape" || event.key === "Esc" || event.keyCode === 27;

export const isTab = (event: KeyboardEvent): boolean => event.key === "Tab" || event.keyCode === 9;

export const isBackspace = (event: KeyboardEvent): boolean =>
  event.key === "Backspace" || event.keyCode === 8;

export const isLeftArrow = (event: KeyboardEvent): boolean => event.keyCode === 37;

export const isUpArrow = (event: KeyboardEvent): boolean => event.keyCode === 38;

export const isRightArrow = (event: KeyboardEvent): boolean => event.keyCode === 39;

export const isDownArrow = (event: KeyboardEvent): boolean => event.keyCode === 40;

export const isEnter = (event: KeyboardEvent): boolean => event.keyCode === 13;
